// src/contexts/ApiKeysContext.tsx
import React, { createContext, useState, useEffect, useContext } from 'react';
import { fetchCurrentUser } from '../services/userService';
import { AuthContext } from './AuthContext'; // Import AuthContext

interface ApiKeysContextProps {
  isApiKeysSet: boolean | null;
  refreshApiKeysStatus: () => Promise<void>;
}

export const ApiKeysContext = createContext<ApiKeysContextProps>({
  isApiKeysSet: null,
  refreshApiKeysStatus: async () => {},
});

export const ApiKeysProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isApiKeysSet, setIsApiKeysSet] = useState<boolean | null>(null);
  const { isAuthenticated } = useContext(AuthContext); // Get isAuthenticated

  const refreshApiKeysStatus = async () => {
    if (!isAuthenticated) {
      // User is not authenticated; no need to fetch
      setIsApiKeysSet(false);
      return;
    }

    try {
      const user = await fetchCurrentUser();
      setIsApiKeysSet(user.is_api_keys_set);
    } catch (error) {
      console.error('Failed to fetch user data', error);
      setIsApiKeysSet(false);
    }
  };

  useEffect(() => {
    refreshApiKeysStatus();
  }, [isAuthenticated]); // Re-run when authentication status changes

  return (
      <ApiKeysContext.Provider value={{ isApiKeysSet, refreshApiKeysStatus }}>
        {children}
      </ApiKeysContext.Provider>
  );
};
